import { render, staticRenderFns } from "./UserFormEsignature.vue?vue&type=template&id=81852c00&scoped=true&"
import script from "./UserFormEsignature.vue?vue&type=script&lang=js&"
export * from "./UserFormEsignature.vue?vue&type=script&lang=js&"
import style0 from "./UserFormEsignature.vue?vue&type=style&index=0&id=81852c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81852c00",
  null
  
)

export default component.exports